import { inject, Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private readonly toastrService = inject(ToastrService);

  saveSuccess(name: string) {
    return this.success($localize`${name} saved successfully`);
  }

  saveFail(name: string) {
    return this.fail($localize`${name} save failed`);
  }

  emailSuccess(name: string) {
    return this.success($localize`${name} email sent successfully`);
  }

  emailFail(name: string) {
    return this.fail($localize`Failed to send ${name} email`);
  }

  uploadSuccess(name: string) {
    return this.success($localize`${name} uploaded successfully`);
  }

  uploadFail(name: string) {
    return this.fail($localize`Failed to upload ${name} file`);
  }

  success(message: string) {
    return this.toastrService.success(message);
  }

  fail(message: string) {
    return this.toastrService.error(message);
  }
}
